<template>
    <transition name="fade">
        <div v-show="visible" class="share-mask" @click="hide">
            <div class="share-content">
                <img class="share-arrow" src="@/assets/images/home/share-arrow.png" alt="" />

                <div class="share-box">
                    <p>点击右上角 <strong>···</strong></p>
                    <p>选择「发送给朋友」</p>
                    <p>或「分享到朋友圈」</p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ShareGuidance',
    data() {
        return {
            visible: false
        }
    },

    methods: {
        show() {
            this.visible = true
        },

        hide() {
            this.visible = false
        }
    }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: .25s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.share-mask {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .75);
    z-index: 999999;
}

.share-content {
    position: absolute;
    right: 16px;
    top: 12px;
}

.share-arrow {
    width: 90px;
    display: block;
    margin-left: auto;
}

.share-box {
    margin-top: 10px;
    padding: 18px 22px;
    border-radius: 12px;
    background: #fff;
    text-align: center;
    line-height: 1.8;

}

.share-box p {
    font-size: 16px;
}

.share-box strong {
    color: #07C160;
}
</style>